import moment from "moment-timezone";

export function formatDate(date:string, format:string) {
  return moment(date).format(format);
}

export function formatTime(date: string, format: string, timeFormat: string) {
  return moment(date, timeFormat).format(format);
}